// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/Avenir55Roman_normal_normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/Avenir85Heavy_normal_normal.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Avenir";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

}

@font-face {
  font-family: "Avenir-Heavy";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body {
  margin: 0;
  font-family: "Avenir", sans-serif;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  font-family: "Avenir", sans-serif;
}

code {
  font-family: "Avenir", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.select__menu-list {
  scrollbar-width: thin;
  scrollbar-color: #ced0d6 transparent;

  &::-webkit-scrollbar {
    width: 4px !important;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ced0d6;
    border-radius: 50%;
    width: 4px;
  }
}

.add-lang-slect .basic--select .select__control {
  height: 45.33px;
}

.add-lang-slect .select__single-value {
  font-size: 14px;
  line-height: 20px;
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}

.nav-link-subnav.active {
  font-weight: 700;
  text-decoration-line: underline;

}

.nav-link-subnav:hover {
  text-decoration-line: underline;

}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;

}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;

}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;

}
@media (min-width: 40rem) {

  .container {
    max-width: 40rem;

  }

}
@media (min-width: 640px) {

  .container {
    max-width: 640px;

  }

}
@media (min-width: 768px) {

  .container {
    max-width: 768px;

  }

}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;

  }

}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;

  }

}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;

  }

}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;

}
.pointer-events-none {
  pointer-events: none;

}
.visible {
  visibility: visible;

}
.fixed {
  position: fixed;

}
.absolute {
  position: absolute;

}
.relative {
  position: relative;

}
.sticky {
  position: sticky;

}
.inset-0 {
  inset: 0px;

}
.\\!left-0 {
  left: 0px !important;

}
.\\!right-0 {
  right: 0px !important;

}
.\\!right-\\[112px\\] {
  right: 112px !important;

}
.\\!right-\\[133px\\] {
  right: 133px !important;

}
.\\!right-\\[73px\\] {
  right: 73px !important;

}
.bottom-0 {
  bottom: 0px;

}
.bottom-\\[-12px\\] {
  bottom: -12px;

}
.bottom-\\[13px\\] {
  bottom: 13px;

}
.bottom-\\[38px\\] {
  bottom: 38px;

}
.bottom-\\[42px\\] {
  bottom: 42px;

}
.bottom-\\[4px\\] {
  bottom: 4px;

}
.bottom-\\[7px\\] {
  bottom: 7px;

}
.left-0 {
  left: 0px;

}
.left-4 {
  left: 16px;

}
.left-5 {
  left: 20px;

}
.left-8 {
  left: 32px;

}
.left-\\[-4px\\] {
  left: -4px;

}
.left-\\[-8px\\] {
  left: -8px;

}
.left-\\[-9px\\] {
  left: -9px;

}
.left-\\[10px\\] {
  left: 10px;

}
.left-\\[14px\\] {
  left: 14px;

}
.left-\\[16px\\] {
  left: 16px;

}
.left-\\[3\\%\\] {
  left: 3%;

}
.left-\\[50px\\] {
  left: 50px;

}
.left-\\[5px\\] {
  left: 5px;

}
.left-\\[74\\.58px\\] {
  left: 74.58px;

}
.right-0 {
  right: 0px;

}
.right-1 {
  right: 4px;

}
.right-2\\.5 {
  right: 0.625rem;

}
.right-3 {
  right: 12px;

}
.right-4 {
  right: 16px;

}
.right-5 {
  right: 20px;

}
.right-\\[-9px\\] {
  right: -9px;

}
.right-\\[0px\\] {
  right: 0px;

}
.right-\\[10px\\] {
  right: 10px;

}
.right-\\[112px\\] {
  right: 112px;

}
.right-\\[11px\\] {
  right: 11px;

}
.right-\\[12px\\] {
  right: 12px;

}
.right-\\[133px\\] {
  right: 133px;

}
.right-\\[153px\\] {
  right: 153px;

}
.right-\\[162px\\] {
  right: 162px;

}
.right-\\[178px\\] {
  right: 178px;

}
.right-\\[183px\\] {
  right: 183px;

}
.right-\\[184px\\] {
  right: 184px;

}
.right-\\[186px\\] {
  right: 186px;

}
.right-\\[188px\\] {
  right: 188px;

}
.right-\\[193px\\] {
  right: 193px;

}
.right-\\[4\\%\\] {
  right: 4%;

}
.right-\\[40px\\] {
  right: 40px;

}
.right-\\[73px\\] {
  right: 73px;

}
.right-\\[81px\\] {
  right: 81px;

}
.start-1 {
  inset-inline-start: 4px;

}
.start-17 {
  inset-inline-start: 7px;

}
.start-2\\.5 {
  inset-inline-start: 0.625rem;

}
.top-0 {
  top: 0px;

}
.top-1 {
  top: 4px;

}
.top-10 {
  top: 40px;

}
.top-15 {
  top: 5px;

}
.top-16 {
  top: 18px;

}
.top-2 {
  top: 8px;

}
.top-20\\.5 {
  top: 7px;

}
.top-3 {
  top: 12px;

}
.top-7 {
  top: 28px;

}
.top-\\[-1\\.5px\\] {
  top: -1.5px;

}
.top-\\[-11px\\] {
  top: -11px;

}
.top-\\[-1px\\] {
  top: -1px;

}
.top-\\[-20px\\] {
  top: -20px;

}
.top-\\[-30px\\] {
  top: -30px;

}
.top-\\[-33px\\] {
  top: -33px;

}
.top-\\[-40px\\] {
  top: -40px;

}
.top-\\[-8px\\] {
  top: -8px;

}
.top-\\[0px\\] {
  top: 0px;

}
.top-\\[10\\%\\] {
  top: 10%;

}
.top-\\[100px\\] {
  top: 100px;

}
.top-\\[10px\\] {
  top: 10px;

}
.top-\\[1px\\] {
  top: 1px;

}
.top-\\[38px\\] {
  top: 38px;

}
.top-\\[3px\\] {
  top: 3px;

}
.top-\\[40\\%\\] {
  top: 40%;

}
.top-\\[4px\\] {
  top: 4px;

}
.top-px {
  top: 1px;

}
.z-100 {
  z-index: 100;

}
.z-50 {
  z-index: 50;

}
.z-\\[10\\] {
  z-index: 10;

}
.z-\\[11\\] {
  z-index: 11;

}
.z-\\[1\\] {
  z-index: 1;

}
.z-\\[2\\] {
  z-index: 2;

}
.z-\\[5\\] {
  z-index: 5;

}
.z-\\[6\\] {
  z-index: 6;

}
.z-\\[9\\] {
  z-index: 9;

}
.float-right {
  float: right;

}
.float-left {
  float: left;

}
.m-0 {
  margin: 0px;

}
.m-0\\.5 {
  margin: 0.125rem;

}
.m-1\\.5 {
  margin: 0.375rem;

}
.m-auto {
  margin: auto;

}
.mx-1 {
  margin-left: 4px;
  margin-right: 4px;

}
.mx-10 {
  margin-left: 40px;
  margin-right: 40px;

}
.mx-3 {
  margin-left: 12px;
  margin-right: 12px;

}
.mx-5 {
  margin-left: 20px;
  margin-right: 20px;

}
.mx-\\[16px\\] {
  margin-left: 16px;
  margin-right: 16px;

}
.mx-auto {
  margin-left: auto;
  margin-right: auto;

}
.my-1 {
  margin-top: 4px;
  margin-bottom: 4px;

}
.my-2 {
  margin-top: 8px;
  margin-bottom: 8px;

}
.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;

}
.my-\\[24px\\] {
  margin-top: 24px;
  margin-bottom: 24px;

}
.\\!mt-2 {
  margin-top: 8px !important;

}
.-mb-2 {
  margin-bottom: -8px;

}
.-mb-3 {
  margin-bottom: -12px;

}
.-mb-px {
  margin-bottom: -1px;

}
.-mt-1 {
  margin-top: -4px;

}
.-mt-2 {
  margin-top: -8px;

}
.mb-1 {
  margin-bottom: 4px;

}
.mb-2 {
  margin-bottom: 8px;

}
.mb-3 {
  margin-bottom: 12px;

}
.mb-4 {
  margin-bottom: 16px;

}
.mb-5 {
  margin-bottom: 20px;

}
.mb-6 {
  margin-bottom: 24px;

}
.mb-8 {
  margin-bottom: 32px;

}
.mb-\\[10px\\] {
  margin-bottom: 10px;

}
.mb-\\[1em\\] {
  margin-bottom: 1em;

}
.mb-\\[5px\\] {
  margin-bottom: 5px;

}
.me-2 {
  margin-inline-end: 8px;

}
.ml-1 {
  margin-left: 4px;

}
.ml-10 {
  margin-left: 40px;

}
.ml-2 {
  margin-left: 8px;

}
.ml-3 {
  margin-left: 12px;

}
.ml-4 {
  margin-left: 16px;

}
.ml-5 {
  margin-left: 20px;

}
.ml-6 {
  margin-left: 24px;

}
.ml-7 {
  margin-left: 28px;

}
.ml-\\[10px\\] {
  margin-left: 10px;

}
.ml-\\[13px\\] {
  margin-left: 13px;

}
.ml-\\[18px\\] {
  margin-left: 18px;

}
.ml-\\[72px\\] {
  margin-left: 72px;

}
.mr-0 {
  margin-right: 0px;

}
.mr-1 {
  margin-right: 4px;

}
.mr-10 {
  margin-right: 40px;

}
.mr-2 {
  margin-right: 8px;

}
.mr-3 {
  margin-right: 12px;

}
.mr-4 {
  margin-right: 16px;

}
.mr-5 {
  margin-right: 20px;

}
.mr-8 {
  margin-right: 32px;

}
.mr-\\[10px\\] {
  margin-right: 10px;

}
.ms-2 {
  margin-inline-start: 8px;

}
.mt-0 {
  margin-top: 0px;

}
.mt-1 {
  margin-top: 4px;

}
.mt-1\\.5 {
  margin-top: 0.375rem;

}
.mt-10 {
  margin-top: 40px;

}
.mt-16 {
  margin-top: 18px;

}
.mt-2 {
  margin-top: 8px;

}
.mt-20 {
  margin-top: 5rem;

}
.mt-3 {
  margin-top: 12px;

}
.mt-4 {
  margin-top: 16px;

}
.mt-5 {
  margin-top: 20px;

}
.mt-6 {
  margin-top: 24px;

}
.mt-7 {
  margin-top: 28px;

}
.mt-8 {
  margin-top: 32px;

}
.mt-\\[-12px\\] {
  margin-top: -12px;

}
.mt-\\[-5px\\] {
  margin-top: -5px;

}
.mt-\\[-6px\\] {
  margin-top: -6px;

}
.mt-\\[1\\.5em\\] {
  margin-top: 1.5em;

}
.mt-\\[10px\\] {
  margin-top: 10px;

}
.mt-\\[18px\\] {
  margin-top: 18px;

}
.mt-\\[1em\\] {
  margin-top: 1em;

}
.mt-\\[5px\\] {
  margin-top: 5px;

}
.mt-\\[8px\\] {
  margin-top: 8px;

}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

}
.block {
  display: block;

}
.inline-block {
  display: inline-block;

}
.inline {
  display: inline;

}
.flex {
  display: flex;

}
.inline-flex {
  display: inline-flex;

}
.table {
  display: table;

}
.table-cell {
  display: table-cell;

}
.table-row {
  display: table-row;

}
.grid {
  display: grid;

}
.contents {
  display: contents;

}
.list-item {
  display: list-item;

}
.hidden {
  display: none;

}
.\\!h-6 {
  height: 24px !important;

}
.\\!h-9 {
  height: 36px !important;

}
.\\!h-\\[80\\%\\] {
  height: 80% !important;

}
.h-10 {
  height: 40px;

}
.h-12 {
  height: 48px;

}
.h-2 {
  height: 8px;

}
.h-3 {
  height: 12px;

}
.h-30 {
  height: 30px;

}
.h-4 {
  height: 16px;

}
.h-5 {
  height: 20px;

}
.h-7 {
  height: 28px;

}
.h-9 {
  height: 36px;

}
.h-99 {
  height: 26px;

}
.h-\\[100\\%\\] {
  height: 100%;

}
.h-\\[100vh\\] {
  height: 100vh;

}
.h-\\[10px\\] {
  height: 10px;

}
.h-\\[125px\\] {
  height: 125px;

}
.h-\\[12px\\] {
  height: 12px;

}
.h-\\[14px\\] {
  height: 14px;

}
.h-\\[16px\\] {
  height: 16px;

}
.h-\\[18px\\] {
  height: 18px;

}
.h-\\[1px\\] {
  height: 1px;

}
.h-\\[20px\\] {
  height: 20px;

}
.h-\\[22px\\] {
  height: 22px;

}
.h-\\[24px\\] {
  height: 24px;

}
.h-\\[250px\\] {
  height: 250px;

}
.h-\\[25px\\] {
  height: 25px;

}
.h-\\[26px\\] {
  height: 26px;

}
.h-\\[2px\\] {
  height: 2px;

}
.h-\\[30px\\] {
  height: 30px;

}
.h-\\[328px\\] {
  height: 328px;

}
.h-\\[35px\\] {
  height: 35px;

}
.h-\\[36px\\] {
  height: 36px;

}
.h-\\[38px\\] {
  height: 38px;

}
.h-\\[40px\\] {
  height: 40px;

}
.h-\\[42px\\] {
  height: 42px;

}
.h-\\[45px\\] {
  height: 45px;

}
.h-\\[48px\\] {
  height: 48px;

}
.h-\\[4px\\] {
  height: 4px;

}
.h-\\[550px\\] {
  height: 550px;

}
.h-\\[55px\\] {
  height: 55px;

}
.h-\\[5px\\] {
  height: 5px;

}
.h-\\[6px\\] {
  height: 6px;

}
.h-\\[80px\\] {
  height: 80px;

}
.h-\\[80vh\\] {
  height: 80vh;

}
.h-\\[8px\\] {
  height: 8px;

}
.h-\\[auto\\] {
  height: auto;

}
.h-\\[calc\\(100\\%-1rem\\)\\] {
  height: calc(100% - 1rem);

}
.h-auto {
  height: auto;

}
.h-fill-available {
  height: -webkit-fill-available;

}
.h-fit {
  height: fit-content;

}
.h-full {
  height: 100%;

}
.h-px {
  height: 1px;

}
.max-h-0 {
  max-height: 0px;

}
.max-h-\\[100\\%\\] {
  max-height: 100%;

}
.max-h-\\[1000px\\] {
  max-height: 1000px;

}
.max-h-\\[128px\\] {
  max-height: 128px;

}
.max-h-\\[2200px\\] {
  max-height: 2200px;

}
.max-h-\\[240px\\] {
  max-height: 240px;

}
.max-h-\\[241px\\] {
  max-height: 241px;

}
.max-h-\\[325px\\] {
  max-height: 325px;

}
.max-h-\\[36px\\] {
  max-height: 36px;

}
.max-h-\\[400px\\] {
  max-height: 400px;

}
.max-h-\\[70vh\\] {
  max-height: 70vh;

}
.max-h-\\[calc\\(100vh-195px\\)\\] {
  max-height: calc(100vh - 195px);

}
.max-h-full {
  max-height: 100%;

}
.min-h-\\[300px\\] {
  min-height: 300px;

}
.min-h-\\[400px\\] {
  min-height: 400px;

}
.min-h-\\[40px\\] {
  min-height: 40px;

}
.min-h-\\[42px\\] {
  min-height: 42px;

}
.min-h-\\[500px\\] {
  min-height: 500px;

}
.min-h-\\[56px\\] {
  min-height: 56px;

}
.min-h-\\[700px\\] {
  min-height: 700px;

}
.\\!w-\\[141px\\] {
  width: 141px !important;

}
.\\!w-\\[48\\%\\] {
  width: 48% !important;

}
.\\!w-\\[50\\%\\] {
  width: 50% !important;

}
.\\!w-\\[98\\%\\] {
  width: 98% !important;

}
.\\!w-full {
  width: 100% !important;

}
.w-1\\/2 {
  width: 50%;

}
.w-1\\/3 {
  width: 33.333333%;

}
.w-1\\/4 {
  width: 25%;

}
.w-1\\/5 {
  width: 20%;

}
.w-1\\/6 {
  width: 16.666667%;

}
.w-100 {
  width: 108px;

}
.w-101 {
  width: 76px;

}
.w-102 {
  width: 26px;

}
.w-11\\/12 {
  width: 91.666667%;

}
.w-12 {
  width: 48px;

}
.w-146 {
  width: 146px;

}
.w-2 {
  width: 8px;

}
.w-2\\/3 {
  width: 66.666667%;

}
.w-2\\/4 {
  width: 50%;

}
.w-2\\/5 {
  width: 40%;

}
.w-20 {
  width: 5rem;

}
.w-200 {
  width: 200px;

}
.w-24 {
  width: 6rem;

}
.w-3 {
  width: 12px;

}
.w-3\\.5 {
  width: 0.875rem;

}
.w-3\\/4 {
  width: 75%;

}
.w-3\\/6 {
  width: 50%;

}
.w-32 {
  width: 8rem;

}
.w-36 {
  width: 9rem;

}
.w-4 {
  width: 16px;

}
.w-4\\/5 {
  width: 80%;

}
.w-4\\/6 {
  width: 66.666667%;

}
.w-40 {
  width: 10rem;

}
.w-48 {
  width: 12rem;

}
.w-5 {
  width: 20px;

}
.w-5\\/6 {
  width: 83.333333%;

}
.w-56 {
  width: 14rem;

}
.w-7 {
  width: 28px;

}
.w-96 {
  width: 24rem;

}
.w-\\[10\\%\\] {
  width: 10%;

}
.w-\\[100\\%\\] {
  width: 100%;

}
.w-\\[100px\\] {
  width: 100px;

}
.w-\\[101px\\] {
  width: 101px;

}
.w-\\[12\\%\\] {
  width: 12%;

}
.w-\\[120px\\] {
  width: 120px;

}
.w-\\[121px\\] {
  width: 121px;

}
.w-\\[122px\\] {
  width: 122px;

}
.w-\\[125px\\] {
  width: 125px;

}
.w-\\[129px\\] {
  width: 129px;

}
.w-\\[12px\\] {
  width: 12px;

}
.w-\\[130px\\] {
  width: 130px;

}
.w-\\[14px\\] {
  width: 14px;

}
.w-\\[15\\%\\] {
  width: 15%;

}
.w-\\[150px\\] {
  width: 150px;

}
.w-\\[152px\\] {
  width: 152px;

}
.w-\\[158px\\] {
  width: 158px;

}
.w-\\[165px\\] {
  width: 165px;

}
.w-\\[16px\\] {
  width: 16px;

}
.w-\\[175px\\] {
  width: 175px;

}
.w-\\[18\\%\\] {
  width: 18%;

}
.w-\\[18px\\] {
  width: 18px;

}
.w-\\[19\\.3\\%\\] {
  width: 19.3%;

}
.w-\\[198px\\] {
  width: 198px;

}
.w-\\[1px\\] {
  width: 1px;

}
.w-\\[20\\%\\] {
  width: 20%;

}
.w-\\[200px\\] {
  width: 200px;

}
.w-\\[208px\\] {
  width: 208px;

}
.w-\\[20px\\] {
  width: 20px;

}
.w-\\[22px\\] {
  width: 22px;

}
.w-\\[24\\%\\] {
  width: 24%;

}
.w-\\[240px\\] {
  width: 240px;

}
.w-\\[24px\\] {
  width: 24px;

}
.w-\\[25\\%\\] {
  width: 25%;

}
.w-\\[250px\\] {
  width: 250px;

}
.w-\\[25px\\] {
  width: 25px;

}
.w-\\[262px\\] {
  width: 262px;

}
.w-\\[26px\\] {
  width: 26px;

}
.w-\\[293px\\] {
  width: 293px;

}
.w-\\[30\\%\\] {
  width: 30%;

}
.w-\\[30em\\] {
  width: 30em;

}
.w-\\[30px\\] {
  width: 30px;

}
.w-\\[320px\\] {
  width: 320px;

}
.w-\\[32px\\] {
  width: 32px;

}
.w-\\[33\\%\\] {
  width: 33%;

}
.w-\\[358px\\] {
  width: 358px;

}
.w-\\[36px\\] {
  width: 36px;

}
.w-\\[385px\\] {
  width: 385px;

}
.w-\\[40\\%\\] {
  width: 40%;

}
.w-\\[400px\\] {
  width: 400px;

}
.w-\\[40em\\] {
  width: 40em;

}
.w-\\[420px\\] {
  width: 420px;

}
.w-\\[44\\%\\] {
  width: 44%;

}
.w-\\[44px\\] {
  width: 44px;

}
.w-\\[456px\\] {
  width: 456px;

}
.w-\\[49\\%\\] {
  width: 49%;

}
.w-\\[50\\%\\] {
  width: 50%;

}
.w-\\[50px\\] {
  width: 50px;

}
.w-\\[518px\\] {
  width: 518px;

}
.w-\\[54\\%\\] {
  width: 54%;

}
.w-\\[550px\\] {
  width: 550px;

}
.w-\\[572px\\] {
  width: 572px;

}
.w-\\[63\\%\\] {
  width: 63%;

}
.w-\\[65\\%\\] {
  width: 65%;

}
.w-\\[7\\%\\] {
  width: 7%;

}
.w-\\[70\\%\\] {
  width: 70%;

}
.w-\\[70px\\] {
  width: 70px;

}
.w-\\[75\\%\\] {
  width: 75%;

}
.w-\\[80\\%\\] {
  width: 80%;

}
.w-\\[80px\\] {
  width: 80px;

}
.w-\\[85px\\] {
  width: 85px;

}
.w-\\[888px\\] {
  width: 888px;

}
.w-\\[8px\\] {
  width: 8px;

}
.w-\\[90px\\] {
  width: 90px;

}
.w-\\[936px\\] {
  width: 936px;

}
.w-\\[94\\%\\] {
  width: 94%;

}
.w-\\[97\\%\\] {
  width: 97%;

}
.w-\\[98\\%\\] {
  width: 98%;

}
.w-\\[98px\\] {
  width: 98px;

}
.w-\\[99\\%\\] {
  width: 99%;

}
.w-\\[calc\\(25\\%-12px\\)\\] {
  width: calc(25% - 12px);

}
.w-\\[calc\\(50\\%-8px\\)\\] {
  width: calc(50% - 8px);

}
.w-auto {
  width: auto;

}
.w-fit {
  width: fit-content;

}
.w-full {
  width: 100%;

}
.w-max {
  width: max-content;

}
.min-w-20 {
  min-width: 5rem;

}
.min-w-28 {
  min-width: 7rem;

}
.min-w-36 {
  min-width: 9rem;

}
.min-w-40 {
  min-width: 10rem;

}
.min-w-52 {
  min-width: 13rem;

}
.min-w-60 {
  min-width: 15rem;

}
.min-w-64 {
  min-width: 16rem;

}
.min-w-\\[100px\\] {
  min-width: 100px;

}
.min-w-\\[101px\\] {
  min-width: 101px;

}
.min-w-\\[105px\\] {
  min-width: 105px;

}
.min-w-\\[120px\\] {
  min-width: 120px;

}
.min-w-\\[140px\\] {
  min-width: 140px;

}
.min-w-\\[150px\\] {
  min-width: 150px;

}
.min-w-\\[180px\\] {
  min-width: 180px;

}
.min-w-\\[200px\\] {
  min-width: 200px;

}
.min-w-\\[205px\\] {
  min-width: 205px;

}
.min-w-\\[220px\\] {
  min-width: 220px;

}
.min-w-\\[35\\%\\] {
  min-width: 35%;

}
.min-w-\\[36px\\] {
  min-width: 36px;

}
.min-w-\\[467px\\] {
  min-width: 467px;

}
.min-w-\\[60\\%\\] {
  min-width: 60%;

}
.min-w-\\[80px\\] {
  min-width: 80px;

}
.min-w-\\[81px\\] {
  min-width: 81px;

}
.\\!max-w-\\[428px\\] {
  max-width: 428px !important;

}
.\\!max-w-\\[500px\\] {
  max-width: 500px !important;

}
.\\!max-w-\\[none\\] {
  max-width: none !important;

}
.max-w-20 {
  max-width: 5rem;

}
.max-w-24 {
  max-width: 6rem;

}
.max-w-2xl {
  max-width: 42rem;

}
.max-w-36 {
  max-width: 9rem;

}
.max-w-3xl {
  max-width: 48rem;

}
.max-w-40 {
  max-width: 10rem;

}
.max-w-4xl {
  max-width: 56rem;

}
.max-w-\\[100\\%\\] {
  max-width: 100%;

}
.max-w-\\[100px\\] {
  max-width: 100px;

}
.max-w-\\[1024px\\] {
  max-width: 1024px;

}
.max-w-\\[120px\\] {
  max-width: 120px;

}
.max-w-\\[160px\\] {
  max-width: 160px;

}
.max-w-\\[181px\\] {
  max-width: 181px;

}
.max-w-\\[350px\\] {
  max-width: 350px;

}
.max-w-\\[393px\\] {
  max-width: 393px;

}
.max-w-\\[400px\\] {
  max-width: 400px;

}
.max-w-\\[416px\\] {
  max-width: 416px;

}
.max-w-\\[500px\\] {
  max-width: 500px;

}
.max-w-\\[60\\%\\] {
  max-width: 60%;

}
.max-w-\\[80\\%\\] {
  max-width: 80%;

}
.max-w-\\[803px\\] {
  max-width: 803px;

}
.max-w-\\[866px\\] {
  max-width: 866px;

}
.max-w-full {
  max-width: 100%;

}
.max-w-none {
  max-width: none;

}
.max-w-screen-sm {
  max-width: 640px;

}
.flex-1 {
  flex: 1 1;

}
.flex-\\[1_0_0\\] {
  flex: 1 0;

}
.flex-auto {
  flex: 1 1 auto;

}
.flex-shrink-0 {
  flex-shrink: 0;

}
.shrink-0 {
  flex-shrink: 0;

}
.table-auto {
  table-layout: auto;

}
.border-separate {
  border-collapse: separate;

}
.border-spacing-0 {
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);

}
.origin-\\[0\\] {
  transform-origin: 0;

}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.-translate-y-4 {
  --tw-translate-y: -16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.-translate-y-\\[0px\\] {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.-translate-y-\\[20px\\] {
  --tw-translate-y: -20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.-translate-y-\\[28px\\] {
  --tw-translate-y: -28px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.-translate-y-\\[32px\\] {
  --tw-translate-y: -32px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.translate-x-10 {
  --tw-translate-x: 40px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.translate-x-6 {
  --tw-translate-x: 24px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.translate-x-9 {
  --tw-translate-x: 36px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.translate-x-\\[-1\\] {
  --tw-translate-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.rotate-\\[180deg\\] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.cursor-pointer {
  cursor: pointer;

}
.cursor-text {
  cursor: text;

}
.select-none {
  -webkit-user-select: none;
          user-select: none;

}
.resize {
  resize: both;

}
.list-decimal {
  list-style-type: decimal;

}
.list-disc {
  list-style-type: disc;

}
.appearance-none {
  appearance: none;

}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));

}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));

}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));

}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));

}
.flex-row {
  flex-direction: row;

}
.flex-row-reverse {
  flex-direction: row-reverse;

}
.flex-col {
  flex-direction: column;

}
.flex-wrap {
  flex-wrap: wrap;

}
.items-start {
  align-items: flex-start;

}
.items-end {
  align-items: flex-end;

}
.items-center {
  align-items: center;

}
.items-stretch {
  align-items: stretch;

}
.justify-start {
  justify-content: flex-start;

}
.justify-end {
  justify-content: flex-end;

}
.justify-center {
  justify-content: center;

}
.justify-between {
  justify-content: space-between;

}
.gap-0\\.5 {
  gap: 0.125rem;

}
.gap-1 {
  gap: 4px;

}
.gap-1\\.5 {
  gap: 0.375rem;

}
.gap-10 {
  gap: 40px;

}
.gap-16 {
  gap: 18px;

}
.gap-2 {
  gap: 8px;

}
.gap-2\\.5 {
  gap: 0.625rem;

}
.gap-24 {
  gap: 6rem;

}
.gap-3 {
  gap: 12px;

}
.gap-4 {
  gap: 16px;

}
.gap-5 {
  gap: 20px;

}
.gap-6 {
  gap: 24px;

}
.gap-8 {
  gap: 32px;

}
.gap-\\[0px\\] {
  gap: 0px;

}
.gap-\\[10\\] {
  gap: 10;

}
.gap-\\[10px\\] {
  gap: 10px;

}
.gap-\\[12px\\] {
  gap: 12px;

}
.gap-\\[16px\\] {
  gap: 16px;

}
.gap-\\[20px\\] {
  gap: 20px;

}
.gap-\\[24px\\] {
  gap: 24px;

}
.gap-\\[2rem\\] {
  gap: 2rem;

}
.gap-\\[4px\\] {
  gap: 4px;

}
.gap-\\[8px\\] {
  gap: 8px;

}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(4px * var(--tw-space-x-reverse));
  margin-left: calc(4px * calc(1 - var(--tw-space-x-reverse)));

}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * var(--tw-space-y-reverse));

}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));

}
.self-end {
  align-self: flex-end;

}
.self-stretch {
  align-self: stretch;

}
.overflow-auto {
  overflow: auto;

}
.\\!overflow-hidden {
  overflow: hidden !important;

}
.overflow-hidden {
  overflow: hidden;

}
.overflow-scroll {
  overflow: scroll;

}
.overflow-x-auto {
  overflow-x: auto;

}
.overflow-y-auto {
  overflow-y: auto;

}
.overflow-x-hidden {
  overflow-x: hidden;

}
.overflow-y-hidden {
  overflow-y: hidden;

}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}
.text-ellipsis {
  text-overflow: ellipsis;

}
.whitespace-normal {
  white-space: normal;

}
.whitespace-nowrap {
  white-space: nowrap;

}
.whitespace-pre {
  white-space: pre;

}
.break-words {
  overflow-wrap: break-word;

}
.break-all {
  word-break: break-all;

}
.rounded-\\[100px\\] {
  border-radius: 100px;

}
.rounded-\\[48px\\] {
  border-radius: 48px;

}
.rounded-\\[4px\\] {
  border-radius: 4px;

}
.rounded-\\[57px\\] {
  border-radius: 57px;

}
.rounded-\\[8px\\] {
  border-radius: 8px;

}
.rounded-full {
  border-radius: 9999px;

}
.rounded-large {
  border-radius: 1.75rem;

}
.rounded-lg {
  border-radius: 0.5rem;

}
.rounded-md {
  border-radius: 0.375rem;

}
.rounded-xl {
  border-radius: 0.75rem;

}
.\\!rounded-s-lg {
  border-start-start-radius: 0.5rem !important;
  border-end-start-radius: 0.5rem !important;

}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;

}
.rounded-e-full {
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;

}
.rounded-s-full {
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;

}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;

}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;

}
.rounded-bl-\\[0px\\] {
  border-bottom-left-radius: 0px;

}
.rounded-bl-\\[48px\\] {
  border-bottom-left-radius: 48px;

}
.rounded-br-\\[0px\\] {
  border-bottom-right-radius: 0px;

}
.rounded-br-\\[48px\\] {
  border-bottom-right-radius: 48px;

}
.rounded-tl-\\[48px\\] {
  border-top-left-radius: 48px;

}
.rounded-tl-\\[4px\\] {
  border-top-left-radius: 4px;

}
.rounded-tr-\\[48px\\] {
  border-top-right-radius: 48px;

}
.rounded-tr-\\[4px\\] {
  border-top-right-radius: 4px;

}
.border {
  border-width: 1px;

}
.border-0 {
  border-width: 0px;

}
.border-2 {
  border-width: 2px;

}
.border-\\[1px\\] {
  border-width: 1px;

}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;

}
.border-b {
  border-bottom-width: 1px;

}
.border-b-0 {
  border-bottom-width: 0px;

}
.border-b-2 {
  border-bottom-width: 2px;

}
.border-b-4 {
  border-bottom-width: 4px;

}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;

}
.border-b-\\[4px\\] {
  border-bottom-width: 4px;

}
.border-l {
  border-left-width: 1px;

}
.border-l-2 {
  border-left-width: 2px;

}
.border-l-4 {
  border-left-width: 4px;

}
.border-l-8 {
  border-left-width: 8px;

}
.border-r {
  border-right-width: 1px;

}
.border-r-2 {
  border-right-width: 2px;

}
.border-t {
  border-top-width: 1px;

}
.border-t-0 {
  border-top-width: 0px;

}
.border-solid {
  border-style: solid;

}
.border-dashed {
  border-style: dashed;

}
.border-double {
  border-style: double;

}
.border-none {
  border-style: none;

}
.\\!border-primary-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 61 165 / var(--tw-border-opacity, 1)) !important;

}
.\\!border-red {
  --tw-border-opacity: 1 !important;
  border-color: rgb(206 18 31 / var(--tw-border-opacity, 1)) !important;

}
.border-\\[\\#003DA5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 61 165 / var(--tw-border-opacity, 1));

}
.border-\\[\\#CED0D6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(206 208 214 / var(--tw-border-opacity, 1));

}
.border-\\[\\#E2E3E5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 227 229 / var(--tw-border-opacity, 1));

}
.border-blue {
  --tw-border-opacity: 1;
  border-color: rgb(0 36 102 / var(--tw-border-opacity, 1));

}
.border-gray {
  --tw-border-opacity: 1;
  border-color: rgb(226 227 229 / var(--tw-border-opacity, 1));

}
.border-lightGray {
  --tw-border-opacity: 1;
  border-color: rgb(206 208 214 / var(--tw-border-opacity, 1));

}
.border-lighterBlue {
  --tw-border-opacity: 1;
  border-color: rgb(227 236 249 / var(--tw-border-opacity, 1));

}
.border-primary-100 {
  --tw-border-opacity: 1;
  border-color: rgb(0 61 165 / var(--tw-border-opacity, 1));

}
.border-primary-150 {
  --tw-border-opacity: 1;
  border-color: rgb(87 209 255 / var(--tw-border-opacity, 1));

}
.border-primary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(221 227 235 / var(--tw-border-opacity, 1));

}
.border-primary-50 {
  --tw-border-opacity: 1;
  border-color: rgb(0 36 102 / var(--tw-border-opacity, 1));

}
.border-red {
  --tw-border-opacity: 1;
  border-color: rgb(206 18 31 / var(--tw-border-opacity, 1));

}
.border-secondary-200 {
  --tw-border-opacity: 1;
  border-color: rgb(93 96 101 / var(--tw-border-opacity, 1));

}
.border-secondary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(226 227 229 / var(--tw-border-opacity, 1));

}
.border-tertiary-200 {
  --tw-border-opacity: 1;
  border-color: rgb(241 180 52 / var(--tw-border-opacity, 1));

}
.border-tertiary-50 {
  --tw-border-opacity: 1;
  border-color: rgb(206 18 31 / var(--tw-border-opacity, 1));

}
.border-transparent {
  border-color: transparent;

}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));

}
.border-b-gray {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(226 227 229 / var(--tw-border-opacity, 1));

}
.border-l-white {
  --tw-border-opacity: 1;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity, 1));

}
.border-r-white {
  --tw-border-opacity: 1;
  border-right-color: rgb(255 255 255 / var(--tw-border-opacity, 1));

}
.\\!bg-lighestgray {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1)) !important;

}
.\\!bg-primary-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 36 102 / var(--tw-bg-opacity, 1)) !important;

}
.\\!bg-transparent {
  background-color: transparent !important;

}
.bg-\\[\\#CCCCCE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 204 206 / var(--tw-bg-opacity, 1));

}
.bg-\\[\\#DDF8E6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(221 248 230 / var(--tw-bg-opacity, 1));

}
.bg-\\[\\#FFDFDF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 223 223 / var(--tw-bg-opacity, 1));

}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  background-color: rgba(0,0,0,0.5);

}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));

}
.bg-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 102 / var(--tw-bg-opacity, 1));

}
.bg-blueMedium {
  --tw-bg-opacity: 1;
  background-color: rgb(52 111 240 / var(--tw-bg-opacity, 1));

}
.bg-darkGray {
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity, 1));

}
.bg-green {
  --tw-bg-opacity: 1;
  background-color: rgb(0 118 42 / var(--tw-bg-opacity, 1));

}
.bg-greenMedium {
  --tw-bg-opacity: 1;
  background-color: rgb(55 208 109 / var(--tw-bg-opacity, 1));

}
.bg-greenlight {
  --tw-bg-opacity: 1;
  background-color: rgb(221 248 230 / var(--tw-bg-opacity, 1));

}
.bg-greenyellow {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 213 / var(--tw-bg-opacity, 1));

}
.bg-lighestgray {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}
.bg-lightGray {
  --tw-bg-opacity: 1;
  background-color: rgb(206 208 214 / var(--tw-bg-opacity, 1));

}
.bg-lightOrange {
  --tw-bg-opacity: 1;
  background-color: rgb(255 227 207 / var(--tw-bg-opacity, 1));

}
.bg-lightPink {
  --tw-bg-opacity: 1;
  background-color: rgb(177 131 255 / var(--tw-bg-opacity, 1));

}
.bg-lightSkyblue {
  --tw-bg-opacity: 1;
  background-color: rgb(237 245 255 / var(--tw-bg-opacity, 1));

}
.bg-lightYellow {
  --tw-bg-opacity: 1;
  background-color: rgb(242 210 85 / var(--tw-bg-opacity, 1));

}
.bg-lighterBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(227 236 249 / var(--tw-bg-opacity, 1));

}
.bg-lightred {
  --tw-bg-opacity: 1;
  background-color: rgb(255 223 223 / var(--tw-bg-opacity, 1));

}
.bg-orange {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 87 / var(--tw-bg-opacity, 1));

}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 61 165 / var(--tw-bg-opacity, 1));

}
.bg-primary-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}
.bg-primary-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 227 235 / var(--tw-bg-opacity, 1));

}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 102 / var(--tw-bg-opacity, 1));

}
.bg-red {
  --tw-bg-opacity: 1;
  background-color: rgb(206 18 31 / var(--tw-bg-opacity, 1));

}
.bg-redMedium {
  --tw-bg-opacity: 1;
  background-color: rgb(243 60 73 / var(--tw-bg-opacity, 1));

}
.bg-secondary-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 227 229 / var(--tw-bg-opacity, 1));

}
.bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 56 63 / var(--tw-bg-opacity, 1));

}
.bg-skyBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(198 221 250 / var(--tw-bg-opacity, 1));

}
.bg-skyColor {
  --tw-bg-opacity: 1;
  background-color: rgb(83 198 242 / var(--tw-bg-opacity, 1));

}
.bg-tertiary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(206 18 31 / var(--tw-bg-opacity, 1));

}
.bg-tertiary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(175 22 133 / var(--tw-bg-opacity, 1));

}
.bg-transparent {
  background-color: transparent;

}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

}
.bg-yellow {
  --tw-bg-opacity: 1;
  background-color: rgb(255 226 110 / var(--tw-bg-opacity, 1));

}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;

}
.fill-current {
  fill: currentColor;

}
.\\!p-\\[16px\\] {
  padding: 16px !important;

}
.p-0 {
  padding: 0px;

}
.p-0\\.5 {
  padding: 0.125rem;

}
.p-1 {
  padding: 4px;

}
.p-12 {
  padding: 48px;

}
.p-16 {
  padding: 18px;

}
.p-2 {
  padding: 8px;

}
.p-3 {
  padding: 12px;

}
.p-4 {
  padding: 16px;

}
.p-5 {
  padding: 20px;

}
.p-6 {
  padding: 24px;

}
.p-8 {
  padding: 32px;

}
.p-\\[10px\\] {
  padding: 10px;

}
.p-\\[16px\\] {
  padding: 16px;

}
.p-\\[1em\\] {
  padding: 1em;

}
.p-\\[6px\\] {
  padding: 6px;

}
.p-\\[8px\\] {
  padding: 8px;

}
.\\!px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;

}
.\\!px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;

}
.\\!py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;

}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;

}
.px-1 {
  padding-left: 4px;
  padding-right: 4px;

}
.px-10 {
  padding-left: 40px;
  padding-right: 40px;

}
.px-12 {
  padding-left: 48px;
  padding-right: 48px;

}
.px-2 {
  padding-left: 8px;
  padding-right: 8px;

}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;

}
.px-3 {
  padding-left: 12px;
  padding-right: 12px;

}
.px-4 {
  padding-left: 16px;
  padding-right: 16px;

}
.px-5 {
  padding-left: 20px;
  padding-right: 20px;

}
.px-6 {
  padding-left: 24px;
  padding-right: 24px;

}
.px-7 {
  padding-left: 28px;
  padding-right: 28px;

}
.px-8 {
  padding-left: 32px;
  padding-right: 32px;

}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;

}
.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;

}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;

}
.px-\\[28px\\] {
  padding-left: 28px;
  padding-right: 28px;

}
.px-\\[48px\\] {
  padding-left: 48px;
  padding-right: 48px;

}
.px-\\[4px\\] {
  padding-left: 4px;
  padding-right: 4px;

}
.px-\\[7px\\] {
  padding-left: 7px;
  padding-right: 7px;

}
.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;

}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;

}
.py-1 {
  padding-top: 4px;
  padding-bottom: 4px;

}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;

}
.py-2 {
  padding-top: 8px;
  padding-bottom: 8px;

}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;

}
.py-3 {
  padding-top: 12px;
  padding-bottom: 12px;

}
.py-4 {
  padding-top: 16px;
  padding-bottom: 16px;

}
.py-6 {
  padding-top: 24px;
  padding-bottom: 24px;

}
.py-\\[0\\.5em\\] {
  padding-top: 0.5em;
  padding-bottom: 0.5em;

}
.py-\\[0\\.8em\\] {
  padding-top: 0.8em;
  padding-bottom: 0.8em;

}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;

}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;

}
.py-\\[16px\\] {
  padding-top: 16px;
  padding-bottom: 16px;

}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;

}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;

}
.py-\\[2\\.5px\\] {
  padding-top: 2.5px;
  padding-bottom: 2.5px;

}
.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;

}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;

}
.py-\\[32px\\] {
  padding-top: 32px;
  padding-bottom: 32px;

}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;

}
.pb-0 {
  padding-bottom: 0px;

}
.pb-1 {
  padding-bottom: 4px;

}
.pb-16 {
  padding-bottom: 18px;

}
.pb-2 {
  padding-bottom: 8px;

}
.pb-2\\.5 {
  padding-bottom: 0.625rem;

}
.pb-3 {
  padding-bottom: 12px;

}
.pb-4 {
  padding-bottom: 16px;

}
.pb-5 {
  padding-bottom: 20px;

}
.pb-6 {
  padding-bottom: 24px;

}
.pb-7 {
  padding-bottom: 28px;

}
.pb-8 {
  padding-bottom: 32px;

}
.pb-\\[12px\\] {
  padding-bottom: 12px;

}
.pb-\\[16px\\] {
  padding-bottom: 16px;

}
.pb-\\[4px\\] {
  padding-bottom: 4px;

}
.pb-\\[5px\\] {
  padding-bottom: 5px;

}
.pb-\\[8px\\] {
  padding-bottom: 8px;

}
.pl-0 {
  padding-left: 0px;

}
.pl-0\\.5 {
  padding-left: 0.125rem;

}
.pl-1 {
  padding-left: 4px;

}
.pl-12 {
  padding-left: 48px;

}
.pl-14 {
  padding-left: 17px;

}
.pl-16 {
  padding-left: 18px;

}
.pl-2 {
  padding-left: 8px;

}
.pl-3 {
  padding-left: 12px;

}
.pl-4 {
  padding-left: 16px;

}
.pl-5 {
  padding-left: 20px;

}
.pl-6 {
  padding-left: 24px;

}
.pl-72 {
  padding-left: 18rem;

}
.pl-8 {
  padding-left: 32px;

}
.pl-9 {
  padding-left: 36px;

}
.pl-\\[12px\\] {
  padding-left: 12px;

}
.pl-\\[16px\\] {
  padding-left: 16px;

}
.pl-\\[20px\\] {
  padding-left: 20px;

}
.pl-\\[6px\\] {
  padding-left: 6px;

}
.pr-0 {
  padding-right: 0px;

}
.pr-1 {
  padding-right: 4px;

}
.pr-1\\.5 {
  padding-right: 0.375rem;

}
.pr-12 {
  padding-right: 48px;

}
.pr-16 {
  padding-right: 18px;

}
.pr-2 {
  padding-right: 8px;

}
.pr-3 {
  padding-right: 12px;

}
.pr-4 {
  padding-right: 16px;

}
.pr-5 {
  padding-right: 20px;

}
.pr-6 {
  padding-right: 24px;

}
.pr-\\[10px\\] {
  padding-right: 10px;

}
.pr-\\[20px\\] {
  padding-right: 20px;

}
.pr-\\[45px\\] {
  padding-right: 45px;

}
.ps-2 {
  padding-inline-start: 8px;

}
.pt-0 {
  padding-top: 0px;

}
.pt-0\\.5 {
  padding-top: 0.125rem;

}
.pt-1 {
  padding-top: 4px;

}
.pt-16 {
  padding-top: 18px;

}
.pt-2 {
  padding-top: 8px;

}
.pt-2\\.5 {
  padding-top: 0.625rem;

}
.pt-3 {
  padding-top: 12px;

}
.pt-4 {
  padding-top: 16px;

}
.pt-5 {
  padding-top: 20px;

}
.pt-6 {
  padding-top: 24px;

}
.pt-\\[0px\\] {
  padding-top: 0px;

}
.pt-\\[103px\\] {
  padding-top: 103px;

}
.pt-\\[120px\\] {
  padding-top: 120px;

}
.pt-\\[12px\\] {
  padding-top: 12px;

}
.pt-\\[16px\\] {
  padding-top: 16px;

}
.pt-\\[24px\\] {
  padding-top: 24px;

}
.pt-\\[2px\\] {
  padding-top: 2px;

}
.pt-\\[40px\\] {
  padding-top: 40px;

}
.pt-\\[4px\\] {
  padding-top: 4px;

}
.pt-\\[5px\\] {
  padding-top: 5px;

}
.pt-\\[76px\\] {
  padding-top: 76px;

}
.pt-px {
  padding-top: 1px;

}
.text-left {
  text-align: left;

}
.text-center {
  text-align: center;

}
.\\!text-right {
  text-align: right !important;

}
.text-right {
  text-align: right;

}
.text-justify {
  text-align: justify;

}
.align-middle {
  vertical-align: middle;

}
.font-\\[\\'Avenir\\'\\] {
  font-family: 'Avenir';

}
.text-2xl {
  font-size: 24px;
  line-height: 32px;

}
.text-\\[12px\\] {
  font-size: 12px;

}
.text-\\[13px\\] {
  font-size: 13px;

}
.text-\\[14px\\] {
  font-size: 14px;

}
.text-\\[16px\\] {
  font-size: 16px;

}
.text-\\[18px\\] {
  font-size: 18px;

}
.text-\\[22px\\] {
  font-size: 22px;

}
.text-base {
  font-size: 16px;
  line-height: 22px;

}
.text-md {
  font-size: 18px;
  line-height: 24px;

}
.text-sm {
  font-size: 14px;
  line-height: 20px;

}
.text-xl {
  font-size: 20px;
  line-height: 24px;

}
.text-xs {
  font-size: 12px;
  line-height: 14px;

}
.text-xxl {
  font-size: 22px;
  line-height: 32px;

}
.text-xxs {
  font-size: 10px;
  line-height: 12px;

}
.font-\\[350\\] {
  font-weight: 350;

}
.font-\\[800\\] {
  font-weight: 800;

}
.font-black {
  font-weight: 900;

}
.font-bold {
  font-weight: 700;

}
.font-bolder {
  font-weight: 800;

}
.font-light {
  font-weight: 300;

}
.font-lighter {
  font-weight: 350;

}
.font-medium {
  font-weight: 500;

}
.font-normal {
  font-weight: 400;

}
.font-semibold {
  font-weight: 600;

}
.uppercase {
  text-transform: uppercase;

}
.capitalize {
  text-transform: capitalize;

}
.italic {
  font-style: italic;

}
.not-italic {
  font-style: normal;

}
.leading-5 {
  line-height: 1.25rem;

}
.leading-\\[1\\.6em\\] {
  line-height: 1.6em;

}
.leading-\\[14px\\] {
  line-height: 14px;

}
.leading-\\[1\\] {
  line-height: 1;

}
.leading-\\[20px\\] {
  line-height: 20px;

}
.leading-\\[21px\\] {
  line-height: 21px;

}
.leading-\\[22px\\] {
  line-height: 22px;

}
.leading-\\[24px\\] {
  line-height: 24px;

}
.leading-normal {
  line-height: 1.5;

}
.leading-relaxed {
  line-height: 1.625;

}
.leading-snug {
  line-height: 1.375;

}
.leading-tight {
  line-height: 1.25;

}
.tracking-tight {
  letter-spacing: -0.025em;

}
.text-\\[\\#003DA5\\] {
  --tw-text-opacity: 1;
  color: rgb(0 61 165 / var(--tw-text-opacity, 1));

}
.text-\\[\\#003da5\\] {
  --tw-text-opacity: 1;
  color: rgb(0 61 165 / var(--tw-text-opacity, 1));

}
.text-\\[\\#34383F\\] {
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}
.text-\\[\\#34383f\\] {
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}
.text-\\[\\#5D6065\\] {
  --tw-text-opacity: 1;
  color: rgb(93 96 101 / var(--tw-text-opacity, 1));

}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));

}
.text-blue {
  --tw-text-opacity: 1;
  color: rgb(0 36 102 / var(--tw-text-opacity, 1));

}
.text-green {
  --tw-text-opacity: 1;
  color: rgb(0 118 42 / var(--tw-text-opacity, 1));

}
.text-lightGray {
  --tw-text-opacity: 1;
  color: rgb(206 208 214 / var(--tw-text-opacity, 1));

}
.text-placeHolderColor {
  --tw-text-opacity: 1;
  color: rgb(108 108 108 / var(--tw-text-opacity, 1));

}
.text-primary-100 {
  --tw-text-opacity: 1;
  color: rgb(0 61 165 / var(--tw-text-opacity, 1));

}
.text-primary-50 {
  --tw-text-opacity: 1;
  color: rgb(0 36 102 / var(--tw-text-opacity, 1));

}
.text-red {
  --tw-text-opacity: 1;
  color: rgb(206 18 31 / var(--tw-text-opacity, 1));

}
.text-secondary-200 {
  --tw-text-opacity: 1;
  color: rgb(93 96 101 / var(--tw-text-opacity, 1));

}
.text-secondary-300 {
  --tw-text-opacity: 1;
  color: rgb(226 227 229 / var(--tw-text-opacity, 1));

}
.text-secondary-50 {
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}
.text-tertiary-50 {
  --tw-text-opacity: 1;
  color: rgb(206 18 31 / var(--tw-text-opacity, 1));

}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));

}
.underline {
  text-decoration-line: underline;

}
.decoration-solid {
  text-decoration-style: solid;

}
.underline-offset-4 {
  text-underline-offset: 4px;

}
.placeholder-secondary-50::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(52 56 63 / var(--tw-placeholder-opacity, 1));

}
.opacity-0 {
  opacity: 0;

}
.opacity-100 {
  opacity: 1;

}
.opacity-25 {
  opacity: 0.25;

}
.opacity-50 {
  opacity: 0.5;

}
.opacity-75 {
  opacity: 0.75;

}
.opacity-\\[1\\] {
  opacity: 1;

}
.shadow-lg {
  --tw-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.20);
  --tw-shadow-colored: 0 16px 32px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

}
.shadow-md {
  --tw-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.16);
  --tw-shadow-colored: 0 8px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

}
.shadow-sm {
  --tw-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0 4px 8px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

}
.shadow-\\[\\#16093E\\] {
  --tw-shadow-color: #16093E;
  --tw-shadow: var(--tw-shadow-colored);

}
.shadow-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow-color: rgba(0,0,0,0.5);
  --tw-shadow: var(--tw-shadow-colored);

}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;

}
.outline-0 {
  outline-width: 0px;

}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);

}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;

}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);

}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

}
.duration-150 {
  transition-duration: 150ms;

}
.duration-200 {
  transition-duration: 200ms;

}
.duration-300 {
  transition-duration: 300ms;

}
.duration-700 {
  transition-duration: 700ms;

}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

}
.\\[appearance\\:textfield\\] {
  appearance: textfield;

}

/* .regform input{
  @apply block w-full p-4 text-sm  bg-transparent rounded-lg border border-lightGray  focus:outline-none focus:ring-0 focus:border-primary-100 h-[42px]
} */
/* .regform label{
  @apply absolute text-sm text-secondary-50 duration-300 transform -translate-y-[0px] scale-75 top-16 origin-[0] bg-white  px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-16 peer-focus:scale-75 peer-focus:-translate-y-[28px] rtl:peer-focus:translate-x-1/2 rtl:peer-focus:left-auto start-17 cursor-text font-['Lato'] font-normal
} */
input:disabled {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}

button:disabled {
  cursor: not-allowed;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(221 227 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}

button:disabled:hover {
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(221 227 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}

.select--is-disabled .select__control--is-disabled {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}

.select--is-disabled .select__control--is-disabled .select__indicators {
  display: none;

}

.form-select input {
  height: auto;

}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.card {
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 10px;
  box-shadow: 5px 5px hsla(0, 0%, 0%, 1);
  padding: 20px;
  margin: 10px;
  text-align: center;
  max-width: 250px;
  display: inline-block;
}

/* width */
.custome-scroll::-webkit-scrollbar {
  width: 8px;

}

.custome-scroll-x::-webkit-scrollbar {
  height: 6px;
  padding-left: 100px;

}

/* Track */
.custome-scroll::-webkit-scrollbar-track {
  display: none;

}

/* Handle */
.custome-scroll::-webkit-scrollbar-thumb {
  border-radius: 8px;
  --tw-bg-opacity: 1;
  background-color: rgb(226 227 229 / var(--tw-bg-opacity, 1));

}

/* Handle on hover */
.custome-scroll::-webkit-scrollbar-thumb:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 56 63 / var(--tw-bg-opacity, 1));

}

/*card title Traning*/

.textWithellipsis3line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.videoClass>video {
  border: 1px solid transparent;
  border-radius: 12px;
}

.blockquoteClass p {
  padding: 15px;
  background: #eee;
  border-radius: 5px;
}

.blockquoteClass p::before {
  content: "\\201C";
}

.blockquoteClass p::after {
  content: "\\201D";
}

.search>input:focus {
  border: 1px solid #003da5;
  background: #e3ecf9;
  color: #34383f;
}

.troubleshoot>div>div>button>span {
  padding-top: 8px;
  padding-bottom: 8px;

}

.troubleshoot>div>div>button>span>a {
  font-size: 18px;
  line-height: 24px;

}

.troubleshoot>div>div>button {
  border-radius: 0px;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.troubleshoot>div>div>ul {
  border-radius: 0px;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.troubleshootBorderBottom {
  border-bottom-right-radius: 0.5em !important;
}

.generalExtraInstruction>ul {
  padding-left: 15px;
}

.generalExtraInstruction>ul>li::marker {
  color: #5d6065;
}

.pricefilter>.select__control>.select__value-container--is-multi {
  height: 42px;
  min-height: 38px;
  width: 80%;
  flex-wrap: nowrap;

}

@media print {
  #printConfirmation {
    display: none !important;
  }
}

.material-class-container {
  width: 600px;
  display: flex;
  flex-wrap: wrap;
}

.material-class-item {
  display: flex;
  width: 30%;
  margin-bottom: 16px;
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

.report-table-header-cell {
  position: relative;
  font-weight: 600;
}

.bg-ongoing {
  background-color: #CCF0F7;
}

.select__control.select__control--is-focused {
  border-color: #003DA5;
}

.customDateSize .relative {
  width: 100%
}

.transparentBorderRight {
  border-right: solid 2px transparent;
}

.transparentBorderLeft {
  border-left: solid 2px transparent;
}
/* added for accessbility ( only for keyboard event ) uasage*/
button:focus { 
  outline: 3px solid #333;
  outline-offset: 3px;
   }
button:focus:not(:focus-visible) {
      outline: none;
      outline-offset: 0;
}
.permission-table td input[type="checkbox"]:focus{
  border:3px solid #34383f;
}

.select__input-container:not([data-value=""]){
  overflow: hidden;
}
.troubleshoot .accordion .accordion-item img, video {
  max-width: fit-content !important;
  height: auto !important;
}

.rbt input{
  transition-duration: 300ms;
  font-size: 14px;
  line-height: 20px;
  padding: 12px;
  --tw-border-opacity: 1;
  border-color: rgb(206 208 214);
  border-width: 1px;
  border-radius: 0.5rem;
  appearance: none;
  width: 100%;
  height: 38px;
}
.rbt-input.focus{
  border-color: rgb(0 61 165) !important;
  border-width: 1px !important;
  appearance: none;
  outline: none;
}
.rbt-menu.dropdown-menu.show{
  z-index: 1000;
   position: absolute;
    left: 0px;
    top: 0px;
    display: block;
    max-height: 300px;
    overflow: auto;
    transform: translate(0px, 38px);
    background-color: #fff;
    border-color: rgb(206 208 214);
    border-width: 1px;
    border-radius: 0.5rem;
}
.rbt-menu.dropdown-menu .dropdown-item {
  display: block;
  width: 100%;
  padding: 4px;
  clear: both;
  font-weight: 400;
  color: rgb(0, 0, 0);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.placeholder\\:text-sm::placeholder {
  font-size: 14px;
  line-height: 20px;

}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;

}
.after\\:left-\\[5px\\]::after {
  content: var(--tw-content);
  left: 5px;

}
.after\\:top-\\[1px\\]::after {
  content: var(--tw-content);
  top: 1px;

}
.after\\:block::after {
  content: var(--tw-content);
  display: block;

}
.after\\:h-\\[12px\\]::after {
  content: var(--tw-content);
  height: 12px;

}
.after\\:w-\\[6px\\]::after {
  content: var(--tw-content);
  width: 6px;

}
.after\\:rotate-45::after {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.after\\:border-b-\\[2px\\]::after {
  content: var(--tw-content);
  border-bottom-width: 2px;

}
.after\\:border-r-\\[2px\\]::after {
  content: var(--tw-content);
  border-right-width: 2px;

}
.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));

}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);

}
.first\\:border-0:first-child {
  border-width: 0px;

}
.first\\:pl-0:first-child {
  padding-left: 0px;

}
.last\\:border-0:last-child {
  border-width: 0px;

}
.checked\\:border-primary-50:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 36 102 / var(--tw-border-opacity, 1));

}
.checked\\:bg-primary-50:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 102 / var(--tw-bg-opacity, 1));

}
.hover\\:block:hover {
  display: block;

}
.hover\\:scale-100:hover {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.hover\\:border-0:hover {
  border-width: 0px;

}
.hover\\:border-primary-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 61 165 / var(--tw-border-opacity, 1));

}
.hover\\:border-primary-150:hover {
  --tw-border-opacity: 1;
  border-color: rgb(87 209 255 / var(--tw-border-opacity, 1));

}
.hover\\:bg-lighestgray:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}
.hover\\:bg-lightSkyblue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 245 255 / var(--tw-bg-opacity, 1));

}
.hover\\:bg-primary-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 61 165 / var(--tw-bg-opacity, 1));

}
.hover\\:bg-primary-150:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(87 209 255 / var(--tw-bg-opacity, 1));

}
.hover\\:bg-primary-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}
.hover\\:bg-tertiary-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(206 18 31 / var(--tw-bg-opacity, 1));

}
.hover\\:text-primary-50:hover {
  --tw-text-opacity: 1;
  color: rgb(0 36 102 / var(--tw-text-opacity, 1));

}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));

}
.hover\\:underline:hover {
  text-decoration-line: underline;

}
.hover\\:underline-offset-4:hover {
  text-underline-offset: 4px;

}
.focus\\:border-primary-100:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 61 165 / var(--tw-border-opacity, 1));

}
.focus\\:bg-lighestgray:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}
.focus\\:bg-lightSkyblue:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(237 245 255 / var(--tw-bg-opacity, 1));

}
.focus\\:bg-primary-150:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(87 209 255 / var(--tw-bg-opacity, 1));

}
.focus\\:text-primary-50:focus {
  --tw-text-opacity: 1;
  color: rgb(0 36 102 / var(--tw-text-opacity, 1));

}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;

}
.focus\\:outline-1:focus {
  outline-width: 1px;

}
.focus\\:outline-offset-2:focus {
  outline-offset: 2px;

}
.focus\\:outline-black:focus {
  outline-color: #000000;

}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

}
.focus\\:ring-primary-50:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 36 102 / var(--tw-ring-opacity, 1));

}
.active\\:no-underline:active {
  text-decoration-line: none;

}
.disabled\\:border-0:disabled {
  border-width: 0px;

}
.disabled\\:bg-lighestgray:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));

}
.disabled\\:bg-primary-150:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(87 209 255 / var(--tw-bg-opacity, 1));

}
.disabled\\:bg-primary-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(221 227 235 / var(--tw-bg-opacity, 1));

}
.disabled\\:text-secondary-50:disabled {
  --tw-text-opacity: 1;
  color: rgb(52 56 63 / var(--tw-text-opacity, 1));

}
.group:hover .group-hover\\:block {
  display: block;

}
.group:hover .group-hover\\:flex {
  display: flex;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:left-\\[12px\\] {
  left: 12px;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:left-\\[18px\\] {
  left: 18px;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-1\\/2 {
  top: 50%;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[20\\%\\] {
  top: 20%;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[20px\\] {
  top: 20px;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[22px\\] {
  top: 22px;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[23px\\] {
  top: 23px;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[28px\\] {
  top: 28px;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[40\\%\\] {
  top: 40%;

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:left-\\[14px\\] {
  left: 14px;

}
.peer:focus ~ .peer-focus\\:left-\\[16px\\] {
  left: 16px;

}
.peer:focus ~ .peer-focus\\:top-16 {
  top: 18px;

}
.peer:focus ~ .peer-focus\\:top-2 {
  top: 8px;

}
.peer:focus ~ .peer-focus\\:top-20\\.5 {
  top: 7px;

}
.peer:focus ~ .peer-focus\\:top-\\[-1\\.5px\\] {
  top: -1.5px;

}
.peer:focus ~ .peer-focus\\:top-\\[0px\\] {
  top: 0px;

}
.peer:focus ~ .peer-focus\\:h-\\[1px\\] {
  height: 1px;

}
.peer:focus ~ .peer-focus\\:h-\\[6px\\] {
  height: 6px;

}
.peer:focus ~ .peer-focus\\:-translate-y-0 {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:-translate-y-4 {
  --tw-translate-y: -16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:-translate-y-\\[0px\\] {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:-translate-y-\\[20px\\] {
  --tw-translate-y: -20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:-translate-y-\\[28px\\] {
  --tw-translate-y: -28px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:-translate-y-\\[32px\\] {
  --tw-translate-y: -32px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .peer-focus\\:items-center {
  align-items: center;

}
.peer:focus ~ .peer-focus\\:gap-\\[0px\\] {
  gap: 0px;

}
.peer:focus ~ .peer-focus\\:px-2 {
  padding-left: 8px;
  padding-right: 8px;

}
.peer:focus ~ .peer-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;

}
.peer:focus ~ .peer-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:transition-none {
    transition-property: none;

  }

}
@media (min-width: 768px) {

  .md\\:inset-0 {
    inset: 0px;

  }

  .md\\:w-full {
    width: 100%;

  }

  .md\\:p-5 {
    padding: 20px;

  }

}
.peer:focus ~ .rtl\\:peer-focus\\:left-auto:where([dir="rtl"], [dir="rtl"] *) {
  left: auto;

}
.peer:focus ~ .rtl\\:peer-focus\\:translate-x-1\\/2:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
.peer:focus ~ .rtl\\:peer-focus\\:translate-x-1\\/4:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

}
@media (prefers-color-scheme: dark) {

  .dark\\:text-secondary-50 {
    --tw-text-opacity: 1;
    color: rgb(52 56 63 / var(--tw-text-opacity, 1));

  }

  .dark\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));

  }

}
.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  appearance: none;

}
.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  appearance: none;

}
.\\[\\&\\>svg\\]\\:h-5>svg {
  height: 20px;

}
.\\[\\&\\>svg\\]\\:w-5>svg {
  width: 20px;

}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4CAAgE;;AAElE;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,4CAAgE;AAClE;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;;EAEpC;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;AACjB;;AAGE;EAAA,eAA6B;EAA7B,iBAA6B;EAA7B,oBAA6B;EAA7B;;AAA6B;;AAI7B;EAAA,gBAA0B;EAA1B;;AAA0B;;AAI1B;EAAA;;AAAgB;;AAGlB;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;;AAAoB;AAApB;;EAAA;IAAA;;EAAoB;;AAAA;AAApB;;EAAA;IAAA;;EAAoB;;AAAA;AAApB;;EAAA;IAAA;;EAAoB;;AAAA;AAApB;;EAAA;IAAA;;EAAoB;;AAAA;AAApB;;EAAA;IAAA;;EAAoB;;AAAA;AAApB;;EAAA;IAAA;;EAAoB;;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,yDAAmB;EAAnB;;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB;;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;AAAnB;EAAA;;AAAmB;;AAEnB;;GAEG;AACH;;GAEG;AAED;EAAA,mBAAwC;EAAxC,kBAAwC;EAAxC;;AAAwC;;AAIxC;EAAA,mBAA2H;EAA3H,kBAA2H;EAA3H,kBAA2H;EAA3H,4DAA2H;EAA3H,oBAA2H;EAA3H;;AAA2H;;AAA3H;EAAA,kBAA2H;EAA3H,kBAA2H;EAA3H,4DAA2H;EAA3H,oBAA2H;EAA3H;;AAA2H;;AAI3H;EAAA,mBAAwC;EAAxC,kBAAwC;EAAxC;;AAAwC;;AAIxC;EAAA;;AAAa;;AAIb;EAAA;;AAAa;;AAGf,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,UAAU;AAER;EAAA;;AAAc;;AAId;EAAA,WAAyB;EAAzB;;AAAyB;;AAG3B,UAAU;AAER;EAAA;;AAAa;;AAGf,WAAW;AAET;EAAA,kBAAqC;EAArC,kBAAqC;EAArC;;AAAqC;;AAGvC,oBAAoB;AAElB;EAAA,kBAAsB;EAAtB;;AAAsB;;AAGxB,qBAAqB;;AAErB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAGE;EAAA,gBAAe;EAAf;;AAAe;;AAIf;EAAA,eAAc;EAAd;;AAAc;;AAGhB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAGE;EAAA,YAAgD;EAAhD,gBAAgD;EAAhD,UAAgD;EAAhD;;AAAgD;;AAGlD;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;AACA,6DAA6D;AAC7D;EACE,uBAAuB;EACvB,mBAAmB;GAClB;AACH;MACM,aAAa;MACb,iBAAiB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;GACZ,kBAAkB;IACjB,SAAS;IACT,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,qBAAqB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;AAzUA;EAAA,eAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,0BAyUC;EAzUD,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,gBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,eAyUC;EAzUD,eAyUC;EAzUD;;AAyUC;AAzUD;EAAA,iBAyUC;EAzUD,iBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,oBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,oBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,oBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,8BAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,2GAyUC;EAzUD,yGAyUC;EAzUD;;AAyUC;AAzUD;EAAA,oBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,kBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,oBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,qBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,eAyUC;EAzUD,eAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,uBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,sBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,uBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,uBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,uBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,iBAyUC;EAzUD,iBAyUC;EAzUD;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,iBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,8BAyUC;EAzUD;;AAyUC;AAzUD;EAAA,2GAyUC;EAzUD,yGAyUC;EAzUD;;AAyUC;AAzUD;;EAAA;IAAA;;EAyUC;;AAAA;AAzUD;;EAAA;IAAA;;EAyUC;;EAzUD;IAAA;;EAyUC;;EAzUD;IAAA;;EAyUC;;AAAA;AAzUD;EAAA;;AAyUC;AAzUD;EAAA,qBAyUC;EAzUD;;AAyUC;AAzUD;EAAA,qBAyUC;EAzUD;;AAyUC;AAzUD;;EAAA;IAAA,oBAyUC;IAzUD;;EAyUC;;EAzUD;IAAA,oBAyUC;IAzUD;;EAyUC;;AAAA;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC;AAzUD;EAAA;;AAyUC","sourcesContent":["@font-face {\n  font-family: \"Avenir\";\n  font-display: swap;\n  src: url(\"../src/assets/fonts/Avenir55Roman_normal_normal.woff\");\n\n}\n\n@font-face {\n  font-family: \"Avenir-Heavy\";\n  font-display: swap;\n  src: url(\"../src/assets/fonts/Avenir85Heavy_normal_normal.woff\");\n}\n\nbody {\n  margin: 0;\n  font-family: \"Avenir\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  font-family: \"Avenir\", sans-serif;\n}\n\ncode {\n  font-family: \"Avenir\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.select__menu-list {\n  scrollbar-width: thin;\n  scrollbar-color: #ced0d6 transparent;\n\n  &::-webkit-scrollbar {\n    width: 4px !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #ced0d6;\n    border-radius: 50%;\n    width: 4px;\n  }\n}\n\n.add-lang-slect .basic--select .select__control {\n  height: 45.33px;\n}\n\n.add-lang-slect .select__single-value {\n  @apply text-sm text-[#34383F];\n}\n\n.nav-link-subnav.active {\n  @apply font-bold underline;\n}\n\n.nav-link-subnav:hover {\n  @apply underline;\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* .regform input{\n  @apply block w-full p-4 text-sm  bg-transparent rounded-lg border border-lightGray  focus:outline-none focus:ring-0 focus:border-primary-100 h-[42px]\n} */\n/* .regform label{\n  @apply absolute text-sm text-secondary-50 duration-300 transform -translate-y-[0px] scale-75 top-16 origin-[0] bg-white  px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-16 peer-focus:scale-75 peer-focus:-translate-y-[28px] rtl:peer-focus:translate-x-1/2 rtl:peer-focus:left-auto start-17 cursor-text font-['Lato'] font-normal\n} */\ninput:disabled {\n  @apply bg-primary-200 cursor-not-allowed;\n}\n\nbutton:disabled {\n  @apply bg-[#DDE3EB] text-[#34383F] cursor-not-allowed border-none hover:bg-[#DDE3EB] hover:text-[#34383F] hover:border-none;\n}\n\n.select--is-disabled .select__control--is-disabled {\n  @apply bg-primary-200 cursor-not-allowed;\n}\n\n.select--is-disabled .select__control--is-disabled .select__indicators {\n  @apply hidden;\n}\n\n.form-select input {\n  @apply h-auto;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.card {\n  border: 1px solid hsl(0, 0%, 80%);\n  border-radius: 10px;\n  box-shadow: 5px 5px hsla(0, 0%, 0%, 1);\n  padding: 20px;\n  margin: 10px;\n  text-align: center;\n  max-width: 250px;\n  display: inline-block;\n}\n\n/* width */\n.custome-scroll::-webkit-scrollbar {\n  @apply w-[8px];\n}\n\n.custome-scroll-x::-webkit-scrollbar {\n  @apply h-[6px] pl-[100px];\n}\n\n/* Track */\n.custome-scroll::-webkit-scrollbar-track {\n  @apply hidden;\n}\n\n/* Handle */\n.custome-scroll::-webkit-scrollbar-thumb {\n  @apply bg-secondary-300 rounded-[8px];\n}\n\n/* Handle on hover */\n.custome-scroll::-webkit-scrollbar-thumb:hover {\n  @apply bg-secondary-50;\n}\n\n/*card title Traning*/\n\n.textWithellipsis3line {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  box-orient: vertical;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n}\n\n.videoClass>video {\n  border: 1px solid transparent;\n  border-radius: 12px;\n}\n\n.blockquoteClass p {\n  padding: 15px;\n  background: #eee;\n  border-radius: 5px;\n}\n\n.blockquoteClass p::before {\n  content: \"\\201C\";\n}\n\n.blockquoteClass p::after {\n  content: \"\\201D\";\n}\n\n.search>input:focus {\n  border: 1px solid #003da5;\n  background: #e3ecf9;\n  color: #34383f;\n}\n\n.troubleshoot>div>div>button>span {\n  @apply py-[8px];\n}\n\n.troubleshoot>div>div>button>span>a {\n  @apply text-md;\n}\n\n.troubleshoot>div>div>button {\n  border-radius: 0px;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n\n.troubleshoot>div>div>ul {\n  border-radius: 0px;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.troubleshootBorderBottom {\n  border-bottom-right-radius: 0.5em !important;\n}\n\n.generalExtraInstruction>ul {\n  padding-left: 15px;\n}\n\n.generalExtraInstruction>ul>li::marker {\n  color: #5d6065;\n}\n\n.pricefilter>.select__control>.select__value-container--is-multi {\n  @apply w-[80%] h-[42px] min-h-[38px] flex-nowrap;\n}\n\n@media print {\n  #printConfirmation {\n    display: none !important;\n  }\n}\n\n.material-class-container {\n  width: 600px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.material-class-item {\n  display: flex;\n  width: 30%;\n  margin-bottom: 16px;\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n  display: none;\n}\n\n.report-table-header-cell {\n  position: relative;\n  font-weight: 600;\n}\n\n.bg-ongoing {\n  background-color: #CCF0F7;\n}\n\n.select__control.select__control--is-focused {\n  border-color: #003DA5;\n}\n\n.customDateSize .relative {\n  width: 100%\n}\n\n.transparentBorderRight {\n  border-right: solid 2px transparent;\n}\n\n.transparentBorderLeft {\n  border-left: solid 2px transparent;\n}\n/* added for accessbility ( only for keyboard event ) uasage*/\nbutton:focus { \n  outline: 3px solid #333;\n  outline-offset: 3px;\n   }\nbutton:focus:not(:focus-visible) {\n      outline: none;\n      outline-offset: 0;\n}\n.permission-table td input[type=\"checkbox\"]:focus{\n  border:3px solid #34383f;\n}\n\n.select__input-container:not([data-value=\"\"]){\n  overflow: hidden;\n}\n.troubleshoot .accordion .accordion-item img, video {\n  max-width: fit-content !important;\n  height: auto !important;\n}\n\n.rbt input{\n  transition-duration: 300ms;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 12px;\n  --tw-border-opacity: 1;\n  border-color: rgb(206 208 214);\n  border-width: 1px;\n  border-radius: 0.5rem;\n  appearance: none;\n  width: 100%;\n  height: 38px;\n}\n.rbt-input.focus{\n  border-color: rgb(0 61 165) !important;\n  border-width: 1px !important;\n  appearance: none;\n  outline: none;\n}\n.rbt-menu.dropdown-menu.show{\n  z-index: 1000;\n   position: absolute;\n    left: 0px;\n    top: 0px;\n    display: block;\n    max-height: 300px;\n    overflow: auto;\n    transform: translate(0px, 38px);\n    background-color: #fff;\n    border-color: rgb(206 208 214);\n    border-width: 1px;\n    border-radius: 0.5rem;\n}\n.rbt-menu.dropdown-menu .dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 4px;\n  clear: both;\n  font-weight: 400;\n  color: rgb(0, 0, 0);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
